import { Component, OnInit } from '@angular/core';
import { ThirdPartiesService } from '@services/third-parties.service';
import { LoaderService } from '@services/support/loader.service';
import { FlashMessagesService } from '@mobilestar/ngx-flash-messages';

@Component({
  selector: 'app-third-parties',
  templateUrl: './third-parties.component.html',
  styleUrls: ['./third-parties.component.scss']
})
export class ThirdPartiesComponent implements OnInit {

  constructor(
    private thirdPartiesService: ThirdPartiesService,
    private loaderService: LoaderService,
    private flashMessages: FlashMessagesService
  ) { }

  ngOnInit() {
  }

  onCheckAllAccountArchives() {
    this.loaderService.show();
    this.thirdPartiesService.checkAllAccountArchives()
    .then((result: any) => {
      if (result.count > 0) {
        this.flashMessages.show("There is a "+result.count+" archive in progress. Please do not change anything in this page.", { cssClass: 'alert-danger', timeout: 6000, closeOnClick: true });
      } else {
        this.flashMessages.show("There is no archive in progress.", { cssClass: 'alert-success', timeout: 4000, closeOnClick: true });
      }
    })
    .finally(() => {
      this.loaderService.hide();
    });
  }
}
